var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-top"},[_c('Logo',{staticClass:"logo"}),_vm._m(0),_c('p',{staticClass:"quick-login"},[_vm._v("Fast and reliable, bringing infinite convenience to your life")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"app-name"},[_vm._v("Cash"),_c('span',[_vm._v("Agad")])])
}]

export { render, staticRenderFns }